import {createContext, useContext, useState} from "react";

export enum ViewMode {
    Start,
    Survey,
    Result,
}

export type TCustomerDataContext = {
    viewMode: ViewMode;
    setViewMode: (mode: ViewMode) => void;
}

export const CustomerDataContext = createContext<TCustomerDataContext>(null!);

export default function CustomerDataContextProvider(props: { children: React.ReactNode }) {
    const [viewMode, setViewMode] = useState<ViewMode>(ViewMode.Survey);

    const changeViewMode = (mode: ViewMode) => {
        setViewMode(mode);
    }

    return (
        <CustomerDataContext.Provider value={{
            viewMode,
            setViewMode: changeViewMode,
        }}>
            {props.children}
        </CustomerDataContext.Provider>
    )
}

export const useCustomerDataContext = () => {
    return useContext(CustomerDataContext);
}
